import { render, staticRenderFns } from "./goodType.vue?vue&type=template&id=7bf3cea3&scoped=true&"
import script from "./goodType.vue?vue&type=script&lang=js&"
export * from "./goodType.vue?vue&type=script&lang=js&"
import style0 from "./goodType.vue?vue&type=style&index=0&id=7bf3cea3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf3cea3",
  null
  
)

component.options.__file = "goodType.vue"
export default component.exports